<template>
  <div>
    <div class="hlCenter">
      <div class="box_1" style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
        <a
          rel="nofollow"
          target="_blank"
          href="https://ahgcjykjyxgs.qiyukf.com/client?k=dafbd24366a8c31bb28f2737a1b7698e&wp=1&robotShuntSwitch=0&templateId=8136501&language=zh-cn&t=安徽职业与成人教育学习网"
          style="display: block"
        >
          <div class="cc cc1"></div>
          <div class="text_1">在线客服</div>
        </a>
      </div>
      <div class="box_2" style="display: flex;align-items: center;justify-content: center;flex-direction: column;margin-top: 15px;">
        <div class="cc cc2"></div>
        <div class="text_2">电话咨询</div>
        <div class="ccc">
          <p>400-8816-822</p>
        </div>
      </div>

      <div class="box_3" style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-top: 15px;">
        <div class="cc cc3"></div>
 
        <div class="text_2" style="letter-spacing: 0px; width: 44px;    margin-left: 6px;">小程序</div>
        <div class="ccc2" ><img src="../../assets/images/xchengxu.png" alt="安徽职业与成人教育学习网" /></div>
      </div>
      <div class="box_4" style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
        <div class="cc cc4" ></div>
  
        <div class="text_2" style="letter-spacing: 0px; width: 44px;    margin-left: 6px;">公众号</div>
        <div class="ccc3"><img src="../../assets/images/gzhBg.png" alt="安徽职业与成人教育学习网" /></div>
      </div>
      <div class="box_5" @click="gotoTop" style="display: flex;align-items: center;justify-content: center;flex-direction: column;">
        <div class="cc cc5"></div>
        <div class="text_2">回到顶部</div>
      </div>
    </div>
   
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toAppEwm } from '@/api/index.js';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      ewm: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    gotoTop() {
      window.scrollTo({top: 0, behavior: "smooth"} );
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // toAppEwm().then(res => {
    //   this.ewm = res.data.data;
    // });
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.hlCenter {
  cursor: pointer;

  z-index: 2;
  position: fixed;
  top: 22%;
  right: 10px;
  width: 62px;
  height: 480px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px 12px 12px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  /* align-items: center; */
  padding: 30px 13px;
}
.cc {
  width: 24px;
  height: 24px;
}
.box_1 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.cc1 {
  background: url('../../assets/indexImg/cebian1.png') no-repeat;
  background-size: 24px 24px;
}
.cc2 {
  background: url('../../assets/indexImg/cebian2.png') no-repeat;
  background-size: 24px 24px;
}
.cc3 {
  background: url('../../assets/indexImg/cebian3.png') no-repeat;
  background-size: 24px 24px;
}
.cc4 {
  background: url('../../assets/indexImg/cebian4.png') no-repeat;
  background-size: 24px 24px;
}
.cc5 {
  background: url('../../assets/indexImg/cebian5.png') no-repeat;
  background-size: 24px 24px;
}
/* .cc1:hover{
  background: url('../../assets/indexImg/cebian_1.png') no-repeat ;
  background-size: 24px 24px;

} */
.text_1 {
  width: 24px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #9499a2;
  line-height: 14px;
  margin-top: 5px;
}
.text_2 {
  cursor: pointer;
  width: 24px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #9499a2;
  line-height: 14px;
  margin-top: 5px;
}
.box_1:hover .text_1 {
  width: 24px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #4076f6;
  line-height: 14px;
}
.box_1:hover .cc1 {
  background: url('../../assets/indexImg/cebian_1.png') no-repeat;
  background-size: 24px 24px;
}
.box_2:hover .cc2 {
  background: url('../../assets/indexImg/cebian_2.png') no-repeat;
  background-size: 24px 24px;
}

.box_3:hover .cc3 {
  background: url('../../assets/indexImg/cebian_3.png') no-repeat;
  background-size: 24px 24px;
}
.box_4:hover .cc4 {
  background: url('../../assets/indexImg/cebian_4.png') no-repeat;
  background-size: 24px 24px;
}
.box_5:hover .cc5 {
  background: url('../../assets/indexImg/cebian_5.png') no-repeat;
  background-size: 24px 24px;
}
.hlCenter .box_2 .cc {
  position: relative;
}
.hlCenter .box_3 .cc3 {
  position: relative;
}
.hlCenter .box_4 .cc4 {
  position: relative;
}
.hlCenter .box_2 .ccc {
  width: 130px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  background-image: url('../../assets/images/phoneBg.png');
  background-size: 130px 36px;
  background-repeat: no-repeat;
  position: absolute;
  display: none;
  left: -137px;
  top: 137px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}
.hlCenter .box_3 .ccc2 {
  padding: 8px 14px 7px 8px;
  width: 97px;
  height: 90px;
  background-image: url('../../assets/images/ewmBg.png');
  background-size: 97px 90px;
  background-repeat: no-repeat;
  position: absolute;
  display: none;
  left: -105px;
  top: 187px;
  img {
    width: 75px;
    height: 75px;
  }
}
.hlCenter .box_4 .ccc3 {
  padding: 8px 14px 7px 8px;
  width: 97px;
  height: 90px;
  background-image: url('../../assets/images/ewmBg.png');
  background-size: 97px 90px;
  background-repeat: no-repeat;
  position: absolute;
  display: none;
  left: -105px;
  top: 277px;
  img {
    width: 75px;
    height: 75px;
  }
}

.hlCenter .box_2:hover .ccc {
  display: block;
}
.hlCenter .box_3:hover .ccc2 {
  display: block;
}
.hlCenter .box_4:hover .ccc3 {
  display: block;
}
.box_2:hover .text_2 {
  width: 24px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #4076f6;
  line-height: 14px;
}
.box_3:hover .text_2 {
  width: 24px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #4076f6;
  line-height: 14px;
}
.box_4:hover .text_2 {
  width: 24px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #4076f6;
  line-height: 14px;
}
.box_5:hover .text_2 {
  width: 24px;
  height: 34px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #4076f6;
  line-height: 14px;
}
.box_2:hover .cc2 {
  background: url('../../assets/indexImg/cebian_2.png') no-repeat;
  background-size: 24px 24px;
}

</style>
